import { apiClient } from "../config";
import { IsocialLogin } from "typed/requests/IAuth";
async function socialLogin(data: IsocialLogin) {
  const res = await apiClient.post("/admin/social-login", data);
  return res.data;
}

export default socialLogin;
